import { t } from '@web/i18n';
import { AppIcons } from '@web/ui/core/atoms';

export interface SavebarProps {
  open: boolean;
  disabled?: boolean;
  onDiscard: () => void;
  onSave: () => void;
}

export function Savebar({
  open,
  disabled,
  onDiscard,
  onSave,
}: Readonly<SavebarProps>): React.JSX.Element | null {
  if (!open) return null;
  return (
    <section
      aria-label={t('settings.savebar.aria')}
      className="sticky bottom-6 z-20 my-6 flex items-center gap-3 rounded-lg border border-border bg-foreground/95 px-4 py-2.5 text-card shadow-popover backdrop-blur"
    >
      <span className="flex items-center gap-2 text-meta font-medium text-card">
        <span aria-hidden className="inline-block h-2 w-2 rounded-pill bg-tone-amber-fg" />
        {t('settings.savebar.dirty')}
      </span>
      <button
        type="button"
        onClick={onDiscard}
        disabled={disabled}
        className="ml-auto rounded-md border-0 bg-transparent px-3 py-1.5 text-meta font-medium text-card transition-colors hover:bg-card/10 disabled:opacity-50"
      >
        {t('settings.savebar.discard')}
      </button>
      <button
        type="button"
        onClick={onSave}
        disabled={disabled}
        className="inline-flex items-center gap-1.5 rounded-md border-0 bg-primary px-3 py-1.5 text-meta font-medium text-primary-foreground transition-colors hover:bg-primary-hover disabled:opacity-50"
      >
        <AppIcons name="check" size={13} />
        {t('settings.savebar.save')}
      </button>
    </section>
  );
}
